"use client";

import React from "react";
import { Facebook, Twitter, Instagram, Linkedin, Loader, Send } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormControl, FormMessage } from "@/components/ui/form";
const socialLinks = [{
  icon: Facebook,
  href: "#",
  label: "Facebook"
}, {
  icon: Twitter,
  href: "#",
  label: "Twitter"
}, {
  icon: Instagram,
  href: "#",
  label: "Instagram"
}, {
  icon: Linkedin,
  href: "#",
  label: "LinkedIn"
}];
const rentalLinks = [{
  label: "Rent a Car",
  href: "/RentACarPage"
}, {
  label: "Driver FAQ",
  href: "/DriverFAQPage"
}, {
  label: "Vehicle Fleet",
  href: "/RentACarPage"
}, {
  label: "Requirements",
  href: "/DriverFAQPage"
}];
const academyLinks = [{
  label: "Training Academy",
  href: "/TrainingAcademyPage"
}, {
  label: "Start Your Fleet",
  href: "/TrainingAcademyPage"
}, {
  label: "Shop Resources",
  href: "/CartPage"
}, {
  label: "Checkout",
  href: "/CheckoutPage"
}];
function NewsletterForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="rounded-md bg-primary/10 p-4 border border-primary/20">
        <p className="text-sm text-primary-foreground font-medium">{successMessage}</p>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-0">
      <FormField control={control} name="email" rules={{
      required: "Email address is required",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Please enter a valid email address"
      }
    }} render={({
      field
    }) => <FormItem className="space-y-2">
            <FormControl>
              <div className="flex w-full max-w-sm items-center space-x-2">
                <input type="email" placeholder="Enter your email" className="flex h-10 w-full rounded-md border border-secondary-foreground/20 bg-secondary-foreground/5 px-3 py-2 text-sm text-secondary-foreground placeholder:text-secondary-foreground/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:border-transparent disabled:cursor-not-allowed disabled:opacity-50 transition-colors" {...field} />
                <Button type="submit" disabled={isSubmitting} variant="default" className="h-10 px-4">
                  {isSubmitting ? <Loader className="size-4 animate-spin" /> : <>
                      <span className="sr-only">Subscribe</span>
                      <Send className="size-4" />
                    </>}
                </Button>
              </div>
            </FormControl>
            <FormMessage className="text-destructive-foreground/90 text-xs" />
            {submitError && <p className="text-destructive-foreground/90 text-xs mt-1">{submitError}</p>}
          </FormItem>} />
    </Form>;
}
export default function FooterHub() {
  return <section id="footer-hub" className="bg-background">
      <div className="bg-secondary text-secondary-foreground pt-16 pb-8">
        <div className="container mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4 lg:gap-8">
            
            {}
            <div className="flex flex-col space-y-6">
              <Link to="/HomePage" className="inline-block w-fit">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1588353/img/gigfleet_logo_light.png" alt="GigFleet Logo" className="h-7 w-auto object-contain" />
              </Link>
              <p className="text-sm text-secondary-foreground/70 max-w-xs leading-relaxed">
                Empowering gig workers with reliable vehicle rentals and providing aspiring entrepreneurs the tools to build their own fleet.
              </p>
              <div className="flex items-center space-x-4">
                {socialLinks.map((social, i) => {
                const Icon = social.icon;
                return <Link key={i} data-index={i} to={social.href} className="rounded-full bg-secondary-foreground/10 p-2 text-secondary-foreground/80 transition-colors hover:bg-primary hover:text-primary-foreground" aria-label={social.label}>
                      <Icon className="size-4" />
                    </Link>;
              })}
              </div>
            </div>

            {}
            <div>
              <h3 className="mb-6 text-lg font-semibold tracking-tight">Rental Services</h3>
              <ul className="space-y-3">
                {rentalLinks.map((link, i) => <li key={i} data-index={i}>
                    <Link to={link.href} className="text-sm text-secondary-foreground/70 transition-colors hover:text-primary">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </div>

            {}
            <div>
              <h3 className="mb-6 text-lg font-semibold tracking-tight">Training Academy</h3>
              <ul className="space-y-3">
                {academyLinks.map((link, i) => <li key={i} data-index={i}>
                    <Link to={link.href} className="text-sm text-secondary-foreground/70 transition-colors hover:text-primary">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </div>

            {}
            <div>
              <h3 className="mb-6 text-lg font-semibold tracking-tight">Stay Updated</h3>
              <p className="mb-4 text-sm text-secondary-foreground/70 leading-relaxed">
                Subscribe to our newsletter for the latest fleet updates, gig economy tips, and exclusive training offers.
              </p>
              <FormProvider formId="footer-newsletter-form" sectionName="footer-hub" defaultValues={{
              email: ""
            }} submitText="Subscribe" successMessage="Thanks for subscribing to our newsletter!">
                <NewsletterForm />
              </FormProvider>
            </div>
          </div>

          <Separator className="my-12 bg-secondary-foreground/10" />

          {}
          <div className="flex flex-col items-center justify-between space-y-4 text-center md:flex-row md:space-y-0 md:text-left">
            <p className="text-sm text-secondary-foreground/60">
              © {new Date().getFullYear()} GigFleet. All rights reserved.
            </p>
            <div className="flex items-center space-x-6 text-sm text-secondary-foreground/60">
              <Link to="#" className="transition-colors hover:text-primary">
                Privacy Policy
              </Link>
              <Link to="#" className="transition-colors hover:text-primary">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}